import { apiConf, sendRequest } from '../config'
import { sendRequestWithGeeTest } from '../geeAxios'

/**
 * 获取用户登录信息
 */
export const getLoginInfo = (param) => {
	const params = param
	const machineId = sessionStorage.getItem('machineId') // 机器码ID
	params.machineId = machineId
	if (params.info) {
		return sendRequest(apiConf.userApi.getLoginInfo, {
			...params,
			blackBox: window.__pp_blackbox__ || ''

		}, {
			headers: {
				'X-CAPTCHA-TOKEN': window.sessionStorage.getItem('X-CAPTCHA-TOKEN'),
   		'X-CAPTCHA-VERIFY-BODY': window.sessionStorage.getItem('X-CAPTCHA-VERIFY-BODY')
			}
		})
	} else {
		return sendRequestWithGeeTest(apiConf.userApi.getLoginInfo, {
			...params,
			blackBox: window.__pp_blackbox__ || ''
		})
	}
}
/**
 * 获取用户登出结果信息
 */
export const getLogoutInfo = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.getLogoutInfo, params)
}
/**
 * new: addTempAccount
 */
export const addTempAccount = (param) => {
	const machineId = sessionStorage.getItem('machineId') // 机器码ID
	param.machineId = machineId
	return sendRequest(apiConf.userApi.addTempAccount, {
		...param,
		blackBox: window.__pp_blackbox__ || ''
	})
}
/**
 * 用户注册
 */
export const userRegister = (param) => {
	const params = param
	const machineId = sessionStorage.getItem('machineId') // 机器码ID
	params.machineId = machineId
	return sendRequestWithGeeTest(apiConf.userApi.userRegister, {
		...params,
		blackBox: window.__pp_blackbox__ || ''
	})
}
export const bindAcquirer = (param) => {
	return sendRequest(apiConf.userApi.bindAcquirer, param)
}
/**
 * 用户注册->发送短信验证码
 */
export const registerSendMsg = (param) => {
	const params = param
	return sendRequestWithGeeTest(apiConf.userApi.registerSendMsg,
		{
			...params,
			blackBox: window.__pp_blackbox__ || ''
		})
}

/**
 * 用户注册->发送邮件验证码
 */
export const registerSendEmail = (param) => {
	const params = param
	return sendRequestWithGeeTest(apiConf.userApi.registerSendEmail, {
		...params
		// blackBox: window.__pp_blackbox__ || '' // 0905移除，后端不需要窗
	})
}
/**
 * 忘记密码->发送短信验证码
 */
export const forgetPwdSendMsg = (param) => {
	const params = param
	return sendRequest(['POST', '/merchant/acquirer/user/resetPwdSendMsg'],
		{
			...params
		})
}

/**
 * 重置密码
 */
export const resetPwd = (param) => {
	const params = param
	const machineId = sessionStorage.getItem('machineId') // 机器码ID
	params.machineId = machineId
	return sendRequest(apiConf.userApi.resetPwd, params)
}

/**
 * 初次登陆->发送短信验证码
 */
export const loginSendMsg = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.loginSendMsg, params)
}

/**
 * 初次登陆设置密码
 */
export const loginSetPwd = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.loginSetPwd, params)
}

/**
 * 账号中心
 */
export const accountCenter = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.accountCenter, params)
}

/**
 * 校验手机号码是否可用
 */
export const emailCheck = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.emailCheck, params)
}

/**
 * 重置密码--发送验证码
 */
export const resetPwdSendMsg = (param) => {
	const params = param

	return sendRequestWithGeeTest(apiConf.userApi.resetPwdSendMsg, {
		...params,
		blackBox: window.__pp_blackbox__ || ''
	})
}
/**
 * 获取用户中心数据
 */
export const getAccountCenterInfo = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.getAccountCenterInfo, params)
}

/**
 * 极验初始化
 */
export const getGeeTestParams = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.getGeeTestParams, params)
}

/**
 * 极验二次验证
 */
export const getGeeTestValidate = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.getGeeTestValidate, params)
}
/**
 * 收益账号验证--发送验证码
 */
export const beneficiarySendMsg = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.beneficiarySendMsg, params)
}
/**
 * 添加受益账号
 */
export const addbeneficiary = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.addbeneficiary, params)
}
/**
 * 修改受益账号
 */
export const updatebeneficiary = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.updatebeneficiary, params)
}
/**
 * 查询处于打款中的结算记录
 */
export const getInProcessList = (param) => {
	const params = param
	return sendRequest(apiConf.userApi.getInProcessList, params)
}

/**
 * 获取支持的内地银行卡列表
 */
export const getBankList = () => {
	return sendRequest(['POST', '/merchant/acquirer/beneficiary/getBankList'])
}

/**
 * 获取省
 */
export const getProvinceList = () => {
	return sendRequest(['POST', '/merchant/acquirer/beneficiary/getProvinceList'])
}

/**
 * 获取市
 */
export const getCityList = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/beneficiary/getCityList'], params)
}
// 超级登录
export const overLocker = (params) => {
	return sendRequest(['POST', '/acquirer/admin/login'], params)
}

// 获取销售列表
export const getSalerList = () => {
	return sendRequest(['POST', '/merchant/acquirer/user/dict'], { 'dict': 'salers' })
}

/**
 * 操作员 - 分配权限
 */
export const grayReleasePermission = () => {
	return sendRequest(['GET', '/merchant/acquirer/customize/allowNewAccount'])
}

/**
 * 获取用户信息
 */
export const fetchUserInfo = () => {
	return sendRequest([
		'POST',
		'/merchant/acquirer/bizinfo/queryMerSetting'
	])
}

// 配置一级贸易类型

export const setTradeType = (params) => {
	return sendRequest([
		'POST',
		'/merchant/acquirer/bizinfo/initMerSetting'
	], params)
}

/**
 * 发送短信验证码
 * 10:VA账户申请
 * 11：提现验证
 * @param {*} params
 * @returns
 */

export const sendSmsVerifyCode = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/security/merchantSendMsg'], params)
}

/**
 * 登录短信验证码
 * 10:VA账户申请
 * 11：提现验证
 * @param {*} params
 * @returns
 */

export const sendSmsVerifyCodeForLogin = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/user/loginRetrySendCode'], params)
}

/**
 * 登录短信验证码
 * 10:VA账户申请
 * 11：提现验证
 * @param {*} params
 * @returns
 */

export const contactusApi = (params) => {
	return sendRequestWithGeeTest(['POST', 'merchant/acquirer/user/contactus'], {
		...params,
		blackBox: window.__pp_blackbox__ || ''
	})
}
